import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';

const feedback = createReducer(
  {
    sending: false,
    success: false,
    errorMessage: ''
  },
  {
    [ActionTypes.FEEDBACK_REQUEST]: state => {
      return { ...state, sending: true };
    },
    [ActionTypes.FEEDBACK_SUCCESS]: state => {
      return { ...state, sending: false, success: true };
    },
    [ActionTypes.FEEDBACK_ERROR]: (state, { payload }) => {
      return { ...state, sending: false, success: false, errorMessage: payload.error };
    }
  }
);

export default feedback;
